import { handleActions } from 'redux-actions';
import * as actions from '../actions/fnbAction';

const initialState = {
    outlets: [],
    outletsPagination: null,
    outletsLoading: false,
    outletUpdatingIds: [],
    properties: [],
    propertiesLoading: false,
    menus: [],
    menusPagination: null,
    menuItems: [],
    menuItemsPagination: null,
    menuItemsLoading: false,
    menuItemUpdating: false,
    menuSyncing: false,
    menuItemSyncing: false,
    menuDetail: null,
    menuDetailLoading: false,
    menuUpdateLoading: false,
    menuUpdateSuccess: false,
    products: [],
    currentProduct: null,
    productPagination: null,
    menuTranslateLoading: false,
    currentItem: null,
    condiments: [],
    condimentsPagination: null,
    condimentDetail: null,
    condimentDetailLoading: false,
    condimentUpdateLoading: false,
    condimentUpdateSuccess: false,
    condimentTranslateLoading: false,
    condimentSyncing: false,
    options: [],
    optionsPagination: null,
    optionDetail: null,
    optionDetailLoading: false,
    optionUpdateLoading: false,
    optionUpdateSuccess: false,
    optionTranslateLoading: false,
    optionSyncing: false,
    productTranslateLoading: false,
    loading: false,
    syncing: false,
    productSyncing: false,
    updating: false,
    error: null,
};

export default handleActions(
    {
        [actions.FNB_GET_OUTLETS]: (state) => ({
            ...state,
            outletsLoading: true,
        }),
        [actions.FNB_GET_OUTLETS_SUCCESS]: (state, action) => {
            const payload = action.payload || {};
            const items = payload.items || payload.data || payload || [];
            const append = Boolean(payload.append);
            const outlets = append ? [...(state.outlets || []), ...items] : items;
            return {
                ...state,
                outletsLoading: false,
                outlets,
                outletsPagination: payload.pagination || null,
            };
        },
        [actions.FNB_GET_OUTLETS_FAIL]: (state, action) => ({
            ...state,
            outletsLoading: false,
            error: action.payload,
        }),
        [actions.FNB_GET_PROPERTIES]: (state) => ({
            ...state,
            propertiesLoading: true,
        }),
        [actions.FNB_GET_PROPERTIES_SUCCESS]: (state, action) => ({
            ...state,
            propertiesLoading: false,
            properties: action.payload || [],
        }),
        [actions.FNB_GET_PROPERTIES_FAIL]: (state, action) => ({
            ...state,
            propertiesLoading: false,
            error: action.payload,
        }),

        [actions.FNB_SYNC_OUTLETS]: (state) => ({
            ...state,
            syncing: true,
        }),
        [actions.FNB_SYNC_OUTLETS_SUCCESS]: (state) => ({
            ...state,
            syncing: false,
        }),
        [actions.FNB_SYNC_OUTLETS_FAIL]: (state, action) => ({
            ...state,
            syncing: false,
            error: action.payload,
        }),
        [actions.FNB_UPDATE_OUTLET]: (state, action) => ({
            ...state,
            outletUpdatingIds: [
                ...(state.outletUpdatingIds || []),
                action.payload?.outletId,
            ].filter(Boolean),
        }),
        [actions.FNB_UPDATE_OUTLET_SUCCESS]: (state, action) => ({
            ...state,
            outletUpdatingIds: (state.outletUpdatingIds || []).filter(
                id => id !== action.payload?.outletId
            ),
        }),
        [actions.FNB_UPDATE_OUTLET_FAIL]: (state, action) => ({
            ...state,
            outletUpdatingIds: (state.outletUpdatingIds || []).filter(
                id => id !== action.payload?.outletId
            ),
            error: action.payload?.error || action.payload,
        }),

        [actions.FNB_GET_MENUS]: (state) => ({
            ...state,
            loading: true,
        }),
        [actions.FNB_GET_MENUS_SUCCESS]: (state, action) => {
            const payload = action.payload || {};
            const menus = payload.items || payload.menus || payload || [];
            const pagination = payload.pagination || null;
            const totalCount = Number(pagination?.totalCount) || 0;
            const pageSize = Number(pagination?.pageSize) || 0;
            const totalPage = pageSize ? Math.ceil(totalCount / pageSize) : 0;
            return {
                ...state,
                loading: false,
                menus,
                menusPagination: pagination
                    ? { ...pagination, totalPage }
                    : null,
            };
        },
        [actions.FNB_GET_MENUS_FAIL]: (state, action) => ({
            ...state,
            loading: false,
            error: action.payload,
        }),
        [actions.FNB_GET_MENU_ITEMS]: (state) => ({
            ...state,
            menuItemsLoading: true,
        }),
        [actions.FNB_GET_MENU_ITEMS_SUCCESS]: (state, action) => {
            const payload = action.payload || {};
            const menuItems = payload.items || payload.menuItems || payload || [];
            const pagination = payload.pagination || null;
            const totalCount = Number(pagination?.totalCount) || 0;
            const pageSize = Number(pagination?.pageSize) || 0;
            const totalPage = pageSize ? Math.ceil(totalCount / pageSize) : 0;
            return {
                ...state,
                menuItemsLoading: false,
                menuItems,
                menuItemsPagination: pagination
                    ? { ...pagination, totalPage }
                    : null,
            };
        },
        [actions.FNB_GET_MENU_ITEMS_FAIL]: (state, action) => ({
            ...state,
            menuItemsLoading: false,
            error: action.payload,
        }),
        [actions.FNB_UPDATE_MENU_ITEM]: (state) => ({
            ...state,
            menuItemUpdating: true,
        }),
        [actions.FNB_UPDATE_MENU_ITEM_SUCCESS]: (state) => ({
            ...state,
            menuItemUpdating: false,
        }),
        [actions.FNB_UPDATE_MENU_ITEM_FAIL]: (state, action) => ({
            ...state,
            menuItemUpdating: false,
            error: action.payload,
        }),
        [actions.FNB_SYNC_MENUS]: (state) => ({
            ...state,
            menuSyncing: true,
        }),
        [actions.FNB_SYNC_MENUS_SUCCESS]: (state) => ({
            ...state,
            menuSyncing: false,
        }),
        [actions.FNB_SYNC_MENUS_FAIL]: (state, action) => ({
            ...state,
            menuSyncing: false,
            error: action.payload,
        }),
        [actions.FNB_SYNC_MENU_ITEMS]: (state) => ({
            ...state,
            menuItemSyncing: true,
        }),
        [actions.FNB_SYNC_MENU_ITEMS_SUCCESS]: (state) => ({
            ...state,
            menuItemSyncing: false,
        }),
        [actions.FNB_SYNC_MENU_ITEMS_FAIL]: (state, action) => ({
            ...state,
            menuItemSyncing: false,
            error: action.payload,
        }),

        [actions.FNB_GET_MENU_DETAIL]: (state) => ({
            ...state,
            menuDetailLoading: true,
        }),
        [actions.FNB_GET_MENU_DETAIL_SUCCESS]: (state, action) => ({
            ...state,
            menuDetailLoading: false,
            menuDetail: action.payload,
        }),
        [actions.FNB_GET_MENU_DETAIL_FAIL]: (state, action) => ({
            ...state,
            menuDetailLoading: false,
            error: action.payload,
        }),

        [actions.FNB_UPDATE_MENU]: (state) => ({
            ...state,
            menuUpdateLoading: true,
            menuUpdateSuccess: false,
        }),
        [actions.FNB_UPDATE_MENU_SUCCESS]: (state) => ({
            ...state,
            menuUpdateLoading: false,
            menuUpdateSuccess: true,
        }),
        [actions.FNB_UPDATE_MENU_FAIL]: (state, action) => ({
            ...state,
            menuUpdateLoading: false,
            error: action.payload,
        }),
        [actions.FNB_MENU_TRANSLATE]: (state) => ({
            ...state,
            menuTranslateLoading: true,
        }),
        [actions.FNB_MENU_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            menuTranslateLoading: false,
        }),
        [actions.FNB_MENU_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            menuTranslateLoading: false,
            error: action.payload,
        }),

        [actions.FNB_GET_ITEM_DETAIL]: (state) => ({
            ...state,
            loading: true,
        }),
        [actions.FNB_GET_ITEM_DETAIL_SUCCESS]: (state, action) => ({
            ...state,
            loading: false,
            currentItem: action.payload,
        }),
        [actions.FNB_GET_ITEM_DETAIL_FAIL]: (state, action) => ({
            ...state,
            loading: false,
            error: action.payload,
        }),

        [actions.FNB_GET_CONDIMENTS]: (state) => ({
            ...state,
            loading: true,
        }),
        [actions.FNB_GET_CONDIMENTS_SUCCESS]: (state, action) => {
            const payload = action.payload || {};
            const condiments = payload.items || payload.condiments || payload || [];
            const pagination = payload.pagination || null;
            const totalCount = Number(pagination?.totalCount) || 0;
            const pageSize = Number(pagination?.pageSize) || 0;
            const totalPage = pageSize ? Math.ceil(totalCount / pageSize) : 0;
            return {
                ...state,
                loading: false,
                condiments,
                condimentsPagination: pagination
                    ? { ...pagination, totalPage }
                    : null,
            };
        },
        [actions.FNB_GET_CONDIMENTS_FAIL]: (state, action) => ({
            ...state,
            loading: false,
            error: action.payload,
        }),
        [actions.FNB_SYNC_CONDIMENTS]: (state) => ({
            ...state,
            condimentSyncing: true,
        }),
        [actions.FNB_SYNC_CONDIMENTS_SUCCESS]: (state) => ({
            ...state,
            condimentSyncing: false,
        }),
        [actions.FNB_SYNC_CONDIMENTS_FAIL]: (state, action) => ({
            ...state,
            condimentSyncing: false,
            error: action.payload,
        }),
        // Products
        [actions.FNB_GET_PRODUCTS]: (state) => ({
            ...state,
            loading: true,
        }),
        [actions.FNB_GET_PRODUCTS_SUCCESS]: (state, action) => {
            const payload = action.payload || {};
            const products = payload.data || payload || [];
            const pagination = payload.pagination || null;
            const totalCount = Number(pagination?.totalCount) || 0;
            const pageSize = Number(pagination?.pageSize) || 0;
            const totalPage = pageSize ? Math.ceil(totalCount / pageSize) : 0;
            return {
                ...state,
                loading: false,
                products,
                productPagination: pagination
                    ? { ...pagination, totalPage }
                    : null,
            };
        },
        [actions.FNB_GET_PRODUCTS_FAIL]: (state, action) => ({
            ...state,
            loading: false,
            error: action.payload,
        }),

        [actions.FNB_GET_CONDIMENT_DETAIL]: (state) => ({
            ...state,
            condimentDetailLoading: true,
        }),
        [actions.FNB_GET_CONDIMENT_DETAIL_SUCCESS]: (state, action) => ({
            ...state,
            condimentDetailLoading: false,
            condimentDetail: action.payload,
        }),
        [actions.FNB_GET_CONDIMENT_DETAIL_FAIL]: (state, action) => ({
            ...state,
            condimentDetailLoading: false,
            error: action.payload,
        }),

        [actions.FNB_UPDATE_CONDIMENT]: (state) => ({
            ...state,
            condimentUpdateLoading: true,
            condimentUpdateSuccess: false,
        }),
        [actions.FNB_UPDATE_CONDIMENT_SUCCESS]: (state) => ({
            ...state,
            condimentUpdateLoading: false,
            condimentUpdateSuccess: true,
        }),
        [actions.FNB_UPDATE_CONDIMENT_FAIL]: (state, action) => ({
            ...state,
            condimentUpdateLoading: false,
            error: action.payload,
        }),
        [actions.FNB_CONDIMENT_TRANSLATE]: (state) => ({
            ...state,
            condimentTranslateLoading: true,
        }),
        [actions.FNB_CONDIMENT_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            condimentTranslateLoading: false,
        }),
        [actions.FNB_CONDIMENT_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            condimentTranslateLoading: false,
            error: action.payload,
        }),

        [actions.FNB_GET_OPTIONS]: (state) => ({
            ...state,
            loading: true,
        }),
        [actions.FNB_GET_OPTIONS_SUCCESS]: (state, action) => {
            const payload = action.payload || {};
            const options = payload.items || payload.options || payload || [];
            const pagination = payload.pagination || null;
            const totalCount = Number(pagination?.totalCount) || 0;
            const pageSize = Number(pagination?.pageSize) || 0;
            const totalPage = pageSize ? Math.ceil(totalCount / pageSize) : 0;
            return {
                ...state,
                loading: false,
                options,
                optionsPagination: pagination
                    ? { ...pagination, totalPage }
                    : null,
            };
        },
        [actions.FNB_GET_OPTIONS_FAIL]: (state, action) => ({
            ...state,
            loading: false,
            error: action.payload,
        }),
        [actions.FNB_SYNC_OPTIONS]: (state) => ({
            ...state,
            optionSyncing: true,
        }),
        [actions.FNB_SYNC_OPTIONS_SUCCESS]: (state) => ({
            ...state,
            optionSyncing: false,
        }),
        [actions.FNB_SYNC_OPTIONS_FAIL]: (state, action) => ({
            ...state,
            optionSyncing: false,
            error: action.payload,
        }),
        [actions.FNB_SYNC_PRODUCTS]: (state) => ({
            ...state,
            productSyncing: true,
        }),
        [actions.FNB_SYNC_PRODUCTS_SUCCESS]: (state) => ({
            ...state,
            productSyncing: false,
        }),
        [actions.FNB_SYNC_PRODUCTS_FAIL]: (state, action) => ({
            ...state,
            productSyncing: false,
            error: action.payload,
        }),

        [actions.FNB_GET_PRODUCT_DETAIL]: (state) => ({
            ...state,
            loading: true,
            currentProduct: null,
        }),
        [actions.FNB_GET_PRODUCT_DETAIL_SUCCESS]: (state, action) => ({
            ...state,
            loading: false,
            currentProduct: action.payload,
        }),
        [actions.FNB_GET_PRODUCT_DETAIL_FAIL]: (state, action) => ({
            ...state,
            loading: false,
            error: action.payload,
        }),

        [actions.FNB_GET_OPTION_DETAIL]: (state) => ({
            ...state,
            optionDetailLoading: true,
        }),
        [actions.FNB_GET_OPTION_DETAIL_SUCCESS]: (state, action) => ({
            ...state,
            optionDetailLoading: false,
            optionDetail: action.payload,
        }),
        [actions.FNB_GET_OPTION_DETAIL_FAIL]: (state, action) => ({
            ...state,
            optionDetailLoading: false,
            error: action.payload,
        }),

        [actions.FNB_UPDATE_OPTION]: (state) => ({
            ...state,
            optionUpdateLoading: true,
            optionUpdateSuccess: false,
        }),
        [actions.FNB_UPDATE_OPTION_SUCCESS]: (state) => ({
            ...state,
            optionUpdateLoading: false,
            optionUpdateSuccess: true,
        }),
        [actions.FNB_UPDATE_OPTION_FAIL]: (state, action) => ({
            ...state,
            optionUpdateLoading: false,
            error: action.payload,
        }),
        [actions.FNB_UPDATE_PRODUCT]: (state) => ({
            ...state,
            updating: true,
        }),
        [actions.FNB_UPDATE_PRODUCT_SUCCESS]: (state, action) => ({
            ...state,
            updating: false,
            currentProduct: action.payload,
        }),
        [actions.FNB_UPDATE_PRODUCT_FAIL]: (state, action) => ({
            ...state,
            updating: false,
        }),
        [actions.FNB_OPTION_TRANSLATE]: (state) => ({
            ...state,
            optionTranslateLoading: true,
        }),
        [actions.FNB_OPTION_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            optionTranslateLoading: false,
        }),
        [actions.FNB_OPTION_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            optionTranslateLoading: false,
            error: action.payload,
        }),

        [actions.FNB_CREATE_PRODUCT_TRANSLATE]: (state) => ({
            ...state,
            updating: true,
        }),
        [actions.FNB_CREATE_PRODUCT_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            updating: false,
        }),
        [actions.FNB_CREATE_PRODUCT_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            updating: false,
            error: action.payload,
        }),

        [actions.FNB_UPDATE_PRODUCT_TRANSLATE]: (state) => ({
            ...state,
            updating: true,
        }),
        [actions.FNB_UPDATE_PRODUCT_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            updating: false,
        }),
        [actions.FNB_UPDATE_PRODUCT_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            updating: false,
            error: action.payload,
        }),

        [actions.FNB_DELETE_PRODUCT_TRANSLATE]: (state) => ({
            ...state,
            updating: true,
        }),
        [actions.FNB_DELETE_PRODUCT_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            updating: false,
        }),
        [actions.FNB_DELETE_PRODUCT_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            updating: false,
            error: action.payload,
        }),
        [actions.FNB_PRODUCT_TRANSLATE]: (state) => ({
            ...state,
            productTranslateLoading: true,
        }),
        [actions.FNB_PRODUCT_TRANSLATE_SUCCESS]: (state) => ({
            ...state,
            productTranslateLoading: false,
        }),
        [actions.FNB_PRODUCT_TRANSLATE_FAIL]: (state, action) => ({
            ...state,
            productTranslateLoading: false,
            error: action.payload,
        }),
    },
    initialState
)
